import React from "react";
import { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
import { BiChevronDown } from "react-icons/bi";
import { AiFillStar } from "react-icons/ai";
import { GoPrimitiveDot } from "react-icons/go";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

function App({ item }) {
  return (
    <div  className="shadow-md rounded-md mb-10 p-4 w-96 ml-auto flex flex-row bg-white">
      <div className="w-1/4 text-center">
        <img
          src={require("../assets/index/user.png")}
          alt=""
          className="rounded-full"
        />
       
        <div className="flex items-center justify-center">
          <AiFillStar color="#ED8919" />
          <AiFillStar color="#ED8919" />
          <AiFillStar color="#ED8919" />
          <AiFillStar color="#ED8919" />
          <AiFillStar color="#ED8919" />
          (4.9)
        </div>
        <span className="text-black text-sm">In Person</span>
        <button className="py-0.5 px-4 ml-2 rounded-3xl border border-green bg-green mt-2 text-white">
          online
        </button>

        <div className="flex flex-row mt-4">
          <div className="">
            <p className="text-sm" style={{ color: "#73D0BE" }}>
              Duration
            </p>
            <strong>50 mins</strong>
          </div>
          <div className="ml-5  pl-7" style={{borderLeft:'2px solid #707070'}}>
            <p className="text-sm" style={{ color: "#73D0BE" }}>
              Free
            </p>
            <strong> $140 </strong>
          </div>
        </div>

        {/* <p className="text-black text-sm flex items-center">
                <GoPrimitiveDot color="#73D0BE" /> 8 days ago last activity
            </p>
            <p className="text-black text-sm flex items-center">
                <GoPrimitiveDot color="#73D0BE" /> Within one day response time
            </p> */}
      </div>
      <div className="w-3/4 pl-4 pt-10">
        {/* <div className="flex flex-row justify-between w-10/12">
          <p className="text-green flex items-center px-2 text-sm">
            <GoPrimitiveDot color="#73D0BE" /> Ask Question
          </p>
          <p className="text-green flex items-center px-2 text-sm">
            <GoPrimitiveDot color="#73D0BE" /> Offers Online Session
          </p>
          <p className="text-green flex items-center px-2 text-sm">
            <GoPrimitiveDot color="#73D0BE" /> Accepting clients
          </p>
        </div> */}
         <p className="text-black text-xl font-gilroy mt-4">
                Therapist Specialist
            </p>
        <p className="font-gilroy flex items-center px-2 text-lg w-11/12  leading-5 pt-2">
          {" "}
          Accredited Gestalt Psychotherapist, M.Psych(Gest)
        </p>
        <p className="flex items-center px-2 text-md w-11/12  leading-5 pt-2">
          labore et Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
          do eiusmod tempor incididunt ut labore et
        </p>
        <div className="flex flex-wrap pt-2 ">
          <div className="bg-green py-1 px-4 rounded-full text-green bg-opacity-30 m-1">
            Anxiety
          </div>
          <div className="bg-green py-1 px-4 rounded-full text-green bg-opacity-30 m-1">
            CBT: Cognitive behavioral therapy
          </div>
          <div className="bg-green py-1 px-4 rounded-full text-green bg-opacity-30 m-1">
            Panic attacks
          </div>
          <div className="bg-green py-1 px-4 rounded-full text-green bg-opacity-30 m-1">
            Psychotherapy
          </div>
          <div className="bg-green py-1 px-4 rounded-full text-green bg-opacity-30 m-1">
            Systemic therapy
          </div>
        </div>
        {/* <p className="flex items-center px-2 text-md w-11/12  leading-5 pt-2">
          Send Humera a message to find out about availiablity
        </p> */}
        <div className="flex flex-wrap pt-2  flex-start">
          {!item && (
            <button style={{backgroundColor:'#48D90B'}} className="py-0.5 w-32 mr-1.5 rounded-3xl border border-green bg-green mt-2 text-white">
              Talk Now
            </button>
          )}
          <button style={{backgroundColor:'#FA7268'}} className="py-0.5 w-32 mr-1.5  rounded-3xl border border-green bg-green mt-2 text-white">
            Ask Question
          </button>
          <button style={{backgroundColor:'#73D0BE'}} className="py-0.5 w-32 mr-1.5  rounded-3xl border border-green bg-green mt-2 text-white">
            Check Profile
          </button>
        </div>
        {item && (
          <div className="flex flex-wrap pt-2 justify-between">
            <button className="py-0.5 w-2/12 rounded-3xl  bg-gray-200 mt-2 ">
              19:00
            </button>
            <button className="py-0.5 w-2/12 rounded-3xl  bg-gray-200 mt-2 ">
              ----
            </button>
            <button className="py-0.5 w-2/12 rounded-3xl  bg-gray-200 mt-2 ">
              ----
            </button>
            <button className="py-0.5 w-2/12 rounded-3xl  bg-gray-200 mt-2 ">
              ----
            </button>
            <button className="py-0.5 w-2/12 rounded-3xl  bg-gray-200 mt-2 ">
              19:00
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default App;
